import { Linkedin, Instagram, Twitter } from 'lucide-react';

const footerLinks = {
  legal: [
    { name: 'Privacy Policy', href: 'https://snapbill.app/privacy.html' },
    { name: 'Terms of Service', href: 'https://snapbill.app/terms.html' },
  ],
  company: [
    { name: 'contact@snapbill.app', href: '#' },
    { name: '+964770 979 5415', href: '#' },
  ],
  social: [
    { name: 'Instagram', icon: Instagram, href: 'https://www.instagram.com/snapbill_app/' },
    { name: 'X', icon: Twitter, href: 'https://x.com/snapbill_app' },
  ],
};

const Footer = () => {
  return (
    <footer className="relative py-16 px-6 overflow-hidden">
      <div className="absolute inset-0 bg-black/95 backdrop-blur-xl" />
      <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-transparent" />

      <div className="relative z-10 max-w-7xl mx-auto">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          <div>
            <h3 className="text-2xl font-bold text-white mb-4">SnapBill</h3>
            <p className="text-white/60 text-sm leading-relaxed">
              Create professional invoices in seconds with SnapBill invoice templates. Customize, send, and get paid faster using modern invoice templates designed for businesses and freelancers.
            </p>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4">Legal</h4>
            <ul className="space-y-2">
              {footerLinks.legal.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    className="text-white/60 hover:text-white transition-colors text-sm"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4">Contact</h4>
            <ul className="space-y-2">
              {footerLinks.company.map((link) => (
                <li key={link.name}>
                  <p
                    className="text-white/60 hover:text-white transition-colors text-sm"
                  >
                    {link.name}
                  </p>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4">Follow</h4>
            <div className="flex gap-4">
              {footerLinks.social.map((link) => (
                <a
                  key={link.name}
                  href={link.href}
                  className="w-10 h-10 rounded-full glass-effect flex items-center justify-center text-white/60 hover:text-white hover:bg-white/10 transition-all"
                >
                  <link.icon className="w-5 h-5" />
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10 text-center">
          <p className="text-white/40 text-sm">
            © 2026 SnapBill. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  )
}

export default Footer